module.exports = __webpack_public_path__ + "img/INDUSTRIA_07_prew.8d684d77.jpg";